import { getHttpClient, getPublicHttpClient, errorDesconocido, safeHandle401, handle401 } from "../../utils/httpClient";
import { notification } from "antd";
import { flashError } from "../../utils/flashMessage";

export const GET_REQUEST = "GET_REQUEST";
export const PUT_REQUEST = "PUT_REQUEST";
export const POST_REQUEST = "POST_REQUEST";
export const DELETE_REQUEST = "DELETE_REQUEST";

const show = (section, getRootState) => {
    /**
     * Action Creators / Primary Request
     */
    const error = (error) => {
        return { type: `${section}_REQUEST_ERROR`, error };
    };

    const loading = () => {
        return { type: `${section}_REQUEST_LOADING` };
    };

    const success = (data) => {
        return { type: `${section}_REQUEST_SUCCESS`, data };
    };

    const reset = () => {
        return { type: `${section}_REQUEST_RESET` };
    };

    /**
     * Action Creators / Secondary Request
     */
    const secondaryError = (error) => {
        return { type: `${section}_SECONDARY_REQUEST_ERROR`, error };
    };

    const secondaryLoading = () => {
        return { type: `${section}_SECONDARY_REQUEST_LOADING` };
    };

    const secondarySuccess = (data) => {
        return { type: `${section}_SECONDARY_REQUEST_SUCCESS`, data };
    };

    const secondaryReset = () => {
        return { type: `${section}_SECONDARY_REQUEST_RESET` };
    };

    //TODO: Terminar y probar el isExpire.
    const isNotExpire = (state) => {
        const data = state.data;
        if (data && data.hasOwnProperty("expireIn")) {
            const when = data.expireIn;
            const expire = state.timestamp + when;
            const timestamp = Date.now().valueOf() / 1000;

            // Cache doesn't need to refresh yet!
            if (timestamp < expire) {
                return true;
            }
        }

        return false;
    };

    /**
     *   No sé si tiene sentido, pero al llevar los datos iniciales de un Form al cache
     * no se necesita más hacer un load(), pero para simular y setear el loaded, loading, etc
     * se crea este patron trivial para la petición primaria. El submit siempre es secundario.
     */
    const getEmptyRequestPattern = () => {
        return async (dispatch, getState) => {
            dispatch(loading());
            dispatch(success(true));
            return true;
        };
    };

    /**
     * Basic Request Pattern
     */
    const requestPattern = (
        url,
        method,
        form,
        customError,
        customLoading,
        customSuccess,
        onSuccess = null,
        cache = false
    ) => {
        return async (dispatch, getState) => {
            if (cache && isNotExpire(getRootState(getState()))) {
                return;
            }

            dispatch(customLoading(true));

            const headers = { "Content-Type": "application/json" };

            try {
                const cliente = await getHttpClient(dispatch, getState());

                let response;

                if (method === POST_REQUEST) {
                    response = await cliente.post(url, form, { headers: headers });
                } else if (method === PUT_REQUEST) {
                    response = await cliente.put(url, form, { headers: headers });
                } else if (method === GET_REQUEST) {
                    response = await cliente.get(url, { params: form }, { headers: headers });
                } else if (method === DELETE_REQUEST) {
                    response = await cliente.delete(url, form ? { data: form } : {}, { headers: headers });
                } else {
                    alert("Unknown METHOD in requestPattern");
                }

                dispatch(customSuccess(response.data));

                if (typeof onSuccess === "object" && onSuccess !== null) {
                    notification.success(onSuccess);
                } else if (onSuccess !== null) {
                    onSuccess(dispatch);
                }

                return response.data;
            } catch (e) {
                const test401 = safeHandle401(dispatch, getState);
                test401(e);

                if (e.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    if (e.response.status == 404) {
                        dispatch(customError(e.response.statusText));
                        return e.response.data;
                    } else if (e.response.status != 400) {
                        dispatch(customError(e.response.statusText));
                        errorDesconocido();
                    }

                    return e.response.data;
                }

                dispatch(customError("Unknown error"));
                errorDesconocido();
                return "Error";
            }
        };
    };

    /**
     * Basic Request Pattern
     */
    const requestUnrestrictedPattern = (
        url,
        method,
        form,
        customError,
        customLoading,
        customSuccess,
        onSuccess = null,
        cache = false
    ) => {
        return async (dispatch, getState) => {
            if (cache && isNotExpire(getRootState(getState()))) {
                return;
            }

            dispatch(customLoading(true));

            const headers = { "Content-Type": "application/json" };

            try {
                const cliente = await getPublicHttpClient(dispatch, getState());

                let response;

                if (method === POST_REQUEST) {
                    response = await cliente.post(url, form, { headers: headers });
                } else if (method === PUT_REQUEST) {
                    response = await cliente.put(url, form, { headers: headers });
                } else if (method === GET_REQUEST) {
                    response = await cliente.get(url, { params: form }, { headers: headers });
                } else if (method === DELETE_REQUEST) {
                    response = await cliente.delete(url, {}, { headers: headers });
                } else {
                    alert("Unknown METHOD in requestPattern");
                }

                dispatch(customSuccess(response.data));

                if (typeof onSuccess === "object" && onSuccess !== null) {
                    notification.success(onSuccess);
                } else if (onSuccess !== null) {
                    onSuccess(dispatch);
                }

                return response.data;
            } catch (e) {
                if (e.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    if (e.response.status == 404) {
                        dispatch(customError(e.response.statusText));
                        return e.response.data;
                    } else if (e.response.status != 400) {
                        dispatch(customError(e.response.statusText));
                        errorDesconocido();
                    }

                    return e.response.data;
                }

                dispatch(customError("Unknown error"));
                errorDesconocido();
                return "Error";
            }
        };
    };

    /**
     * Shortcuts for common requests for Primary Requests
     */

    const getCacheUnrestrictedPattern = (url, form, onSucces = null) => {
        return requestUnrestrictedPattern(url, GET_REQUEST, form, error, loading, success, onSucces, true);
    };

    const getCachePattern = (url, form, onSucces = null) => {
        return requestPattern(url, GET_REQUEST, form, error, loading, success, onSucces, true);
    };

    const getPattern = (url, form, onSucces = null) => {
        return requestPattern(url, GET_REQUEST, form, error, loading, success, onSucces, false);
    };

    const putPattern = (url, form, onSucces = null) => {
        return requestPattern(url, PUT_REQUEST, form, error, loading, success, onSucces, false);
    };

    const postPattern = (url, form, onSucces = null) => {
        return requestPattern(url, POST_REQUEST, form, error, loading, success, onSucces, false);
    };

    const deletePattern = (url, form, onSucces = null) => {
        return requestPattern(url, DELETE_REQUEST, form, error, loading, success, onSucces, false);
    };

    /**
     * Shortcuts for common requests for Secondary Requests
     */
    const secondaryGetPattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            GET_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            secondarySuccess,
            onSucces,
            false
        );
    };

    const secondaryPutPattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            PUT_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            secondarySuccess,
            onSucces,
            false
        );
    };

    const secondaryPostPattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            POST_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            secondarySuccess,
            onSucces,
            false
        );
    };

    const secondaryDeletePattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            DELETE_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            secondarySuccess,
            onSucces,
            false
        );
    };

    /**
     * Shortcuts for common requests for Action Requests
     */
    const actionGetPattern = (url, form, onSucces = null) => {
        return requestPattern(url, GET_REQUEST, form, secondaryError, secondaryLoading, success, onSucces, false);
    };

    const actionPutPattern = (url, form, onSucces = null) => {
        return requestPattern(url, PUT_REQUEST, form, secondaryError, secondaryLoading, success, onSucces, false);
    };

    const actionPostPattern = (url, form, onSucces = null) => {
        return requestPattern(url, POST_REQUEST, form, secondaryError, secondaryLoading, success, onSucces, false);
    };

    const actionDeletePattern = (url, form, onSucces = null) => {
        return requestPattern(url, DELETE_REQUEST, form, secondaryError, secondaryLoading, success, onSucces, false);
    };

    /**
     * Selectors
     */

    const isLoaded = (state) => getRootState(state).loaded;
    const isLoading = (state) => getRootState(state).loading;
    const getError = (state) => getRootState(state).error;
    const getData = (state) => getRootState(state).data;

    const isSecondaryLoading = (state) => getRootState(state).subrequest.loading;
    const getSecondaryError = (state) => getRootState(state).subrequest.error;
    const getSecondaryData = (state) => getRootState(state).subrequest.data;
    const getSecondarySuccess = (state) => getRootState(state).subrequest.success;

    const generalDownload = (url, name) => {
        return (dispatch, getState) => {
            dispatch(secondaryLoading(true));

            const cliente = getHttpClient(dispatch, getState());
            cliente.then((axios) => {
                axios
                    .get(url, {
                        responseType: "arraybuffer",
                    })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", `${name}`);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(handle401(dispatch, getState))
                    .catch((e) => {
                        if (e.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (e.response.status == 404) {
                                errorDesconocido();
                                return;
                            }
                        }

                        errorDesconocido();
                    })
                    .finally(() => {
                        dispatch(secondaryReset());
                    });
            });
        };
    };

    const generalPostDownload = (url, name, form) => {
        return (dispatch, getState) => {
            dispatch(secondaryLoading(true));

            const cliente = getHttpClient(dispatch, getState());
            cliente.then((axios) => {
                axios
                    .post(url, form, {
                        responseType: "arraybuffer",
                    })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", `${name}`);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(handle401(dispatch, getState))
                    .catch((e) => {
                        if (e.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (e.response.status == 404) {
                                errorDesconocido();
                                return;
                            } else if (e.response.status == 413) {
                                // CUSTOM
                                // Hoy solo se usa para fallar en los downloadFolders
                                dispatch(secondaryError("Not allowed"));
                                flashError({ description: "The folder is empty or exceeds the 400Mb allowed." });
                                return e.response.data;
                            }
                            
                        }

                        errorDesconocido();
                    })
                    .finally(() => {
                        dispatch(secondaryReset());
                    });
            });
        };
    };

    const download = (url, name) => {
        return (dispatch, getState) => {
            const cliente = getHttpClient(dispatch, getState());
            cliente.then((axios) => {
                axios
                    .get(url, {
                        responseType: "arraybuffer",
                        headers: { Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
                    })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", `${name}.xlsx`);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(handle401(dispatch, getState))
                    .catch((e) => {
                        if (e.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (e.response.status == 404) {
                                alert("Se ha producido un error inesperado ");
                                return;
                            }
                        }

                        errorDesconocido();
                    });
            });
        };
    };

    return {
        /**
         * Action Creators / Primary Request
         */
        error,
        loading,
        success,
        reset,

        /**
         * Action Creators / Secondary Request
         */
        secondaryError,
        secondaryLoading,
        secondarySuccess,
        secondaryReset,

        /**
         * Basic Request Pattern
         */
        requestPattern,

        /**
         * Shortcuts for common requests for Primary Requests
         */
        getEmptyRequestPattern,
        getCachePattern,
        getCacheUnrestrictedPattern,
        getPattern,
        putPattern,
        postPattern,
        deletePattern,

        /**
         * Shortcuts for common requests for Secondary Requests
         */
        secondaryGetPattern,
        secondaryPutPattern,
        secondaryPostPattern,
        secondaryDeletePattern,

        /**
         * Shortcuts for common requests for Action Requests
         */
        actionGetPattern,
        actionPutPattern,
        actionPostPattern,
        actionDeletePattern,

        /**
         * Selectors
         */
        isLoaded,
        isLoading,
        getError,
        getData,
        isSecondaryLoading,
        getSecondaryError,
        getSecondaryData,
        getSecondarySuccess,

        download, //TODO: Ver si se puede realizar con un requestPattern / customSuccess = logica + secondaryReset
        generalDownload,
        generalPostDownload,
    };
};

export default show;
